"use client";

import { usePathname } from "next/navigation";
import { getCookie } from "cookies-next";
import { defaultLanguage, languages, TLanguages } from "./i18n";

export function useLang(): string {
  const pathname = usePathname() || "";
  const slug = pathname.split("/")[1] as string;

  // 1) Se veio na URL e é válido
  if (slug && languages.includes(slug)) {
    return slug;
  }

  // 2) Senão, tenta o cookie NEXT_LOCALE
  const cookie = getCookie("NEXT_LOCALE") as string | undefined;
  if (cookie && languages.includes(cookie as string)) {
    return cookie as string;
  }

  // 3) Fallback
  return defaultLanguage;
}
